import vconst from 'utils/helpers/structs/vconst';

type ExpendTeamLike = {
    income_status?: number | string;
    incomeCount?: number;
    income_count?: number;
    incomePriceSale?: number;
    income_price_sale?: number;
};

type ExpendOtherLike = {
    expendStatus?: number | string;
    expendAmount?: number;
};

type ObjectCardDataLike = {
    expendTeams?: ExpendTeamLike[] | null;
    expends?: ExpendOtherLike[] | null;
};

type ObjectInfoLike = {
    prodPriceSale?: number;
} | null;

/** Активні видатки вкладки «Інше» (суми в БД зі знаком мінус). */
const getOtherExpendsCost = (expends?: ExpendOtherLike[] | null): number => {
    let otherCost = 0;
    expends?.forEach((expend) => {
        if (Number(expend.expendStatus) !== vconst.incomeStatActive) return;
        const amount = Number(expend.expendAmount) || 0;
        if (amount < 0) otherCost += -amount;
    });
    return otherCost;
};

/**
 * Фактична вартість: списані товари + активні послуги.
 * Якщо includeOtherInObjectCost — плюс активні видатки з вкладки «Інше».
 */
export const getActualObjectCost = (
    vObject: ObjectCardDataLike | null | undefined,
    vObjectInfo: ObjectInfoLike,
    includeOtherInObjectCost = false,
): number => {
    const productsSale = Number(vObjectInfo?.prodPriceSale) || 0;

    let servicesSale = 0;
    vObject?.expendTeams?.forEach((expend) => {
        if (Number(expend.income_status) !== vconst.incomeStatActive) return;
        const count = Number(expend.income_count ?? expend.incomeCount ?? 1) || 1;
        const priceSale = Number(expend.income_price_sale ?? expend.incomePriceSale ?? 0);
        servicesSale += count * priceSale;
    });

    const otherCost = includeOtherInObjectCost ? getOtherExpendsCost(vObject?.expends) : 0;

    return Math.round((productsSale + servicesSale + otherCost) * 100) / 100;
};
